export default "__VITE_ASSET__DWh8JRm2__"